import "./index.scss";
// import PadImg from "../../../assets/images/pad/ipad.png";
// import BookmarkImg from "../../../assets/images/pad/bookmark.svg";
// import ControlsImg from "../../../assets/images/pad/controls.svg";
// import FullScreenImg from "../../../assets/images/pad/fullscreen.svg";
// import PlanImg from "../../../assets/images/pad/plan.svg";
// import TitleImg from "../../../assets/images/pad/title.svg";
// import TourImg from "../../../assets/images/pad/tour.svg";
// import ImageImg2 from "../../../assets/images/pad/image.jpg";
import ImageImg from "../../../assets/images/pad/art_gallery_screen.jpg";

import React from "react";

const Pad = () => {
  return (
    <div className={`pad`}>
      <img src={ImageImg} className={`pad__image2`} alt="plan" />
    </div>
    // <div className={`pad`}>
    //   <div className={`pad__position pad__left`}>
    //     <img src={TourImg} className={`pad__tour`} alt="tour" />
    //     <img src={PlanImg} className={`pad__plan`} alt="plan" />
    //   </div>
    //   <div className={`pad__position pad__right`}>
    //     <img src={BookmarkImg} className={`pad__bookmark`} alt="bookmark" />
    //     <img
    //       src={FullScreenImg}
    //       className={`pad__fullscreen`}
    //       alt="fullscreen"
    //     />
    //   </div>
    //   <img src={PadImg} className={`pad__background`} alt="iPad" />
    //   <div className={`pad__image`} style={{backgroundImage: `url(${ImageImg2})`}} />
    //   <img src={TitleImg} className={`pad__position pad__title`} alt="title" />
    //   <img src={ControlsImg} className={`pad__position pad__controls`} alt="controls" />
    // </div>
  );
};

export default Pad;
